/* unplugin-vue-components disabled */import { render } from "./SaveUrlIcon.vue?vue&type=template&id=ace95052"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__